import SectionWrapper from '@/components/feature/SectionWrapper';

const WHATSAPP_URL = 'https://wa.me/923179699957?text=Hi%20Moin%20Khan%20Boxing%20Academy!%20I%20want%20to%20join%20training';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 lg:py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20boxing%20ring%20interior%20with%20dramatic%20cinematic%20lighting%2C%20deep%20red%20spotlights%20on%20black%20background%2C%20smoke%20and%20atmosphere%2C%20professional%20sports%20photography%2C%20high%20contrast%2C%20a%20lone%20boxer%20silhouette%20in%20center%20of%20ring%2C%20premium%20boxing%20gym%20aesthetic&width=1920&height=800&seq=cta-bg-3&orientation=landscape"
          alt="Boxing ring"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-boxing-black/80" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 lg:px-12 text-center">
        <SectionWrapper>
          <span className="section-label">/ Ready to Start?</span>
          <h2 className="heading-mixed text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
            Ready to Step Into
            <br />
            <span className="text-highlight">the Ring?</span>
          </h2>
          <p className="font-poppins text-white/70 text-sm md:text-base max-w-lg mx-auto mt-5 mb-8 leading-relaxed">
            Start your boxing journey with expert coaching. No experience needed — just commitment.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary text-sm md:text-base px-10 py-4"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg" />
            </span>
            Join Now via WhatsApp
          </a>
        </SectionWrapper>
      </div>
    </section>
  );
}
